import * as TYPES from './types'
import { parseNodeContent } from '@/helpers/parserHelper'

export default {
  [TYPES.CHANGE_CONTENT_SYNC_STATUS]: ({ commit }, { syncSuccess }) => {
    if (!syncSuccess) {
      commit(TYPES.SET_CONTENT_SYNCED, { sync: false })
    } else {
      commit(TYPES.SET_CONTENT_SYNCED_DATE, { date: new Date().toISOString() })
      commit(TYPES.SET_CONTENT_SYNCED, { sync: true })
    }
  },
  [TYPES.OFFLINE_INIT]: ({ getters }) => {
    let allImages = []

    if (Array.isArray(getters.getBottles)) {
      allImages.concat(getters.getBottles.map(bottle => bottle.image))
    }

    if (getters.getThemes && Array.isArray(getters.getThemes)) {
      getters.getThemes.forEach(theme => {
        theme.lessonSteps.forEach(lessonStep => {
          lessonStep.lessons.forEach(lesson => {
            parseNodeContent(lesson.content, allImages)
          })
        })
      })
    }

    allImages = allImages.filter(Boolean)

    // Ignore promise on purpose to let them load in event loop
    allImages.forEach(imageUri => {
      const img = new Image()
      img.src = imageUri
    })
  }
}
